/**
 * Szövegvégi replacelés.
 * @param {string} str - A szöveg.
 * @param {string} substr - Amit cserélni szeretnénk.
 * @param {string} newSubstr - Amire cserélni szeretnénk.
 * @returns {string} A kicserélt szöveg.
 */
module.exports.replaceAtEnd = function replaceAtEnd (str, substr, newSubstr) {
  return str.replace(new RegExp(`${ substr }$`), newSubstr)
}
